import styled from "styled-components";

const HeaderStyles = styled.header`
  padding: ${({ theme }) => theme.spacing[24]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
`;

const Header = ({ children, style, className }) => (
  <HeaderStyles style={{ ...style }} className={className}>
    {children}
  </HeaderStyles>
);

export default Header;
